<template>
  <div class="data-picker">
    <span v-if="needText" class="data-picker-text">时间范围：</span>
    <el-date-picker
      v-model="startAndEndTime"
      type="daterange"
      align="center"
      :size="size"
      unlink-panels
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      format="yyyy-MM-dd"
      value-format="yyyy-MM-dd"
      :picker-options="pickerOptions"
      :style="{ width }"
      :clearable="clearable"
      popper-class="date-picker-box"
    ></el-date-picker>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapGetters } from 'vuex'
import constant from '@/utils/constant'

export default {
  name: 'DatePicker',
  props: {
    width: String,
    areaId: [Number, String],
    needText: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: 'medium',
    },
  },
  data() {
    return {
      startAndEndTime: [],
    }
  },
  computed: {
    ...mapGetters({
      userDetail: 'customer/userDetail',
    }),
    agentAreas() {
      return this.userDetail.agentAreas || []
    },
    formatStartAt() {
      let startAt = constant.startDate
      if (this.areaId) {
        const curArea = _.find(this.agentAreas, item => item.id === this.areaId)
        if (moment(curArea.beginAt) > moment(startAt)) {
          startAt = curArea.beginAt
        }
      }
      return moment(startAt).format('YYYY-MM-DD')
    },
    pickerOptions() {
      const shortcuts = []
      const yesterdayDate = moment().subtract(1, 'days')
      const curDate = yesterdayDate.format('YYYY-MM-DD')
      const formatTime = (start, end, text) => {
        let startTime = start.format('YYYY-MM-DD')
        let endTime = end.format('YYYY-MM-DD')
        if (startTime < this.formatStartAt) {
          startTime = this.formatStartAt
        }
        if (endTime > curDate) {
          endTime = curDate
        }
        if (endTime < this.formatStartAt) {
          endTime = curDate
        }
        return {
          text,
          onClick(picker) {
            picker.$emit('pick', [startTime, endTime])
          },
        }
      }
      const weekOfday = parseInt(moment().format('d'))
      const oneMonthAgoFirst = moment().subtract(1, 'months').date(1)
      let curMonthFirst = moment().date(1)
      if (moment(curMonthFirst) > moment(yesterdayDate)) {
        curMonthFirst = moment().subtract(1, 'months').startOf('month')
      }
      const list = [
        {
          text: '昨日',
          start: yesterdayDate,
          end: yesterdayDate,
        },
        {
          text: '上周',
          start: moment().subtract(weekOfday + 6, 'days'),
          end: moment().subtract(weekOfday, 'days'),
        },
        {
          text: '本周',
          start: moment().subtract(weekOfday - 1, 'days'),
          end: moment().add(7 - weekOfday, 'days'),
        },
        {
          text: '上月',
          start: oneMonthAgoFirst,
          end: moment(oneMonthAgoFirst).endOf('month'),
        },
        {
          text: '本月',
          start: curMonthFirst,
          end: yesterdayDate,
        },
        {
          text: '去年',
          start: moment()
            .year(moment().year() - 1)
            .startOf('year'),
          end: moment()
            .year(moment().year() - 1)
            .endOf('year'),
        },
        {
          text: '本年',
          start: moment().startOf('year'),
          end: yesterdayDate,
        },
      ]
      _.forEach(list, item => {
        const result = formatTime(item.start, item.end, item.text)
        if (result) {
          shortcuts.push(result)
        }
      })
      return {
        shortcuts,
        disabledDate: time => {
          return (
            moment(this.formatStartAt) > moment(time) ||
            moment().subtract(1, 'days') < moment(time)
          )
        },
      }
    },
  },
  created() {
    this.initTime()
  },
  watch: {
    startAndEndTime() {
      this.$emit('changeStartAndEndTime', this.startAndEndTime)
    },
  },
  methods: {
    initTime() {
      const yesterdayDate = moment().subtract(1, 'days').format('YYYY-MM-DD')
      let startTime = moment().startOf('month').format('YYYY-MM-DD')
      if (moment(startTime) > moment(yesterdayDate)) {
        startTime = moment()
          .subtract(1, 'months')
          .startOf('month')
          .format('YYYY-MM-DD')
      }
      if (startTime < this.formatStartAt) {
        startTime = this.formatStartAt
      }
      this.startAndEndTime = [startTime, yesterdayDate]
    },
  },
}
</script>

<style lang='scss'>
.data-picker {
  display: flex;
  align-items: center;
  .data-picker-text {
    font-size: 14px;
    color: #606266;
    margin-right: 6px;
  }
}
.date-picker-box {
  .el-picker-panel__body-wrapper {
    padding: 20px 10px 20px 24px;
    .el-picker-panel__sidebar {
      display: flex;
      flex-wrap: wrap;
      width: 120px;
      bottom: 200px;
      top: 20px;
      left: 14px;
      border-right: none;
      .el-picker-panel__shortcut {
        font-size: 14px;
        color: #55acee;
        width: 54px;
        height: 28px;
        background-color: #f5f5f5;
        padding-left: 0;
        margin-right: 5px;
        text-align: center;
      }
    }
    .is-left {
      border: 1px solid #e4e4e4;
      border-right: none;
    }
    .is-right {
      border: 1px solid #e4e4e4;
    }
  }
}
</style>